<mat-carousel
  *ngIf='flashPaymentService.controller.tokenCards.length > 0'
  color=""
  maxWidth="600"
  slideHeight="350px"
  slides=""
  [loop]="true"
  [hideArrows]="flashPaymentService.controller.tokenCards.length < 0"
  [hideIndicators]="false"
  [useKeyboard]="true"
  [useMouseWheel]="false"
  proportion="20"
  class="movil"
  [maintainAspectRatio]="false"
  [autoplay]="false"
  (change)="test($event)"
>
  <mat-carousel-slide
    #matCarouselSlide
    *ngFor="let card of flashPaymentService.controller.tokenCards; let j = index"
    overlayColor="#f2f2f2"
    [hideOverlay]="false"
  >
    <div class="slides_content pad-change-content">
      <div class="credit-card-container" [class]="card.active">
        <div class="credit-card-header">
          <div class="credit-card-title" (click)="flashPaymentService.selectCard(card)" >
            {{card.franchiseName}}
          </div>

          <div class="delete-option" (click)="flashPaymentService.deleteCard(card)">
            <mat-icon>delete_forever</mat-icon>
          </div>
        </div>


        <div class="card-information" (click)="flashPaymentService.selectCard(card)">
          <div class="litle-title">
            N&uacute;mero de tarjeta
          </div>

          <div class="card-number">
            XXXX - XXXX - XXXX - {{card.lastFourDigits}}
          </div>

          <div class="creadit-card-footer">
            <div class="exp-date">
              <div class="text-date">
                Fecha de expiraci&oacute;n
              </div>
              <div class="date-card">
                {{card.expirationDate}}
              </div>
            </div>
            <div class="card-brand">
              <img
                class="user-card"
                src="../../../../../assets/images/visa-2.png"
                alt=""
                *ngIf="card.brandCode === 'V'"
              />
              <img
                class="user-card"
                src="../../../../../assets/images/mastercard-2.png"
                alt=""
                *ngIf="card.brandCode === 'M'"
              />
              <img
                class="user-card"
                src="https://miclaroexpressweb.claropr.com/assets/images/cards/amex.png"
                alt=""
                *ngIf="card.brandCode === 'X'"
              />
              <img
                class="user-card"
                src="../../../../../assets/images/Payment Method/Discover.png"
                alt=""
                *ngIf="card.brandCode === 'D'"
              />
              <img
                class="user-card"
                src="../../../../../assets/images/ath-2.png"
                alt=""
                *ngIf="card.brandCode === 'A'"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-carousel-slide>

</mat-carousel>
